<template>
    <PopupRouterView :showLeftIcon="true" label="Role Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="role"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="roleInput">


        <b-card header="Role" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData" />
						<app-input-textarea id="fieldset-description" label-cols-lg="12"  label="Description" label-for="input-description" size="sm" :model.sync="model.description"  @change="updateData" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "Role Details"
			:bordered="true" :items="roleDetails" 
			:fields="fieldsRoleDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByRoleDetail" 
			:sort-desc.sync="sortDescRoleDetail" small responsive	
			@editButtonMethod="editRowDataRoleDetail"	
			@deleteButtonMethod="deleteRowDataRoleDetail"	
			@showPopupAddMethod="addDataRoleDetail()"	
			@showPopupUploadMethod="showPopupUploadRoleDetail()"
			@downloadMethod="downloadRoleDetail()"
			@addFromClipboardMethod="addFromClipboardRoleDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardRoleDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadRoleDetail"
			tableHeadClass="text-center"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowRoleDetailFilter = !isShowRoleDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowRoleDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Function">
					<v-select id="input-role-details-function-info-table" append-to-body label="name" :options="functionInfos" :value="filterRoleDetail.functionInfoId" :reduce="item => item.id" v-model="filterRoleDetail.functionInfoId" @search="getFunctionInfos" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Allow Create">
					<b-form-checkbox id="input-role-details-allow-create-table" class="float-right" v-model="filterRoleDetail.allowCreate"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Read">
					<b-form-checkbox id="input-role-details-allow-read-table" class="float-right" v-model="filterRoleDetail.allowRead"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Update">
					<b-form-checkbox id="input-role-details-allow-update-table" class="float-right" v-model="filterRoleDetail.allowUpdate"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Delete">
					<b-form-checkbox id="input-role-details-allow-delete-table" class="float-right" v-model="filterRoleDetail.allowDelete"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Show In Menu">
					<b-form-checkbox id="input-role-details-show-in-menu-table" class="float-right" v-model="filterRoleDetail.showInMenu"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Download">
					<b-form-checkbox id="input-role-details-allow-download-table" class="float-right" v-model="filterRoleDetail.allowDownload"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Print">
					<b-form-checkbox id="input-role-details-allow-print-table" class="float-right" v-model="filterRoleDetail.allowPrint"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Upload">
					<b-form-checkbox id="input-role-details-allow-upload-table" class="float-right" v-model="filterRoleDetail.allowUpload"></b-form-checkbox>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( roleDetailPageSize * (currentRoleDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(functionInfo)="row">
				<app-input-combobox-autocomplete :options="functionInfos" optionsLabel="name" optionsKey="id" :id="'input-role-details-function-info-' + row.index" label-cols-lg="12" label="Function" size="sm" :model.sync="row.item.functionInfoId"  @change="saveInputRoleDetail(row.item)" :selected="row.item.functionInfo != null ? row.item.functionInfo.name : ''"  @input="getFunctionInfos" :loading="isFunctionInfoComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(allowCreate)="row">
				<app-input-checkbox :id="'input-role-details-allow-create-row-' + row.index" label-cols-lg="12" label="" :model.sync="row.item.allowCreate" @change="saveInputRoleDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(allowRead)="row">
				<app-input-checkbox :id="'input-role-details-allow-read-row-' + row.index" label-cols-lg="12" label="" :model.sync="row.item.allowRead" @change="saveInputRoleDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(allowUpdate)="row">
				<app-input-checkbox :id="'input-role-details-allow-update-row-' + row.index" label-cols-lg="12" label="" :model.sync="row.item.allowUpdate" @change="saveInputRoleDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(allowDelete)="row">
				<app-input-checkbox :id="'input-role-details-allow-delete-row-' + row.index" label-cols-lg="12" label="" :model.sync="row.item.allowDelete" @change="saveInputRoleDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(showInMenu)="row">
				<app-input-checkbox :id="'input-role-details-show-in-menu-row-' + row.index" label-cols-lg="12" label="" :model.sync="row.item.showInMenu" @change="saveInputRoleDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(allowDownload)="row">
				<app-input-checkbox :id="'input-role-details-allow-download-row-' + row.index" label-cols-lg="12" label="" :model.sync="row.item.allowDownload" @change="saveInputRoleDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(allowPrint)="row">
				<app-input-checkbox :id="'input-role-details-allow-print-row-' + row.index" label-cols-lg="12" label="" :model.sync="row.item.allowPrint" @change="saveInputRoleDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(allowUpload)="row">
				<app-input-checkbox :id="'input-role-details-allow-upload-row-' + row.index" label-cols-lg="12" label="" :model.sync="row.item.allowUpload" @change="saveInputRoleDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>

								
			<template v-slot:form-add-detail>
				<RoleDetailInput 
					:model="modelRoleDetail"
					:openPopup="isShowPopupRoleDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataRoleDetail"/>
			</template>
			<template v-slot:upload-detail>
					<RoleDetailUpload
					:openPopup="isShowPopupUploadRoleDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataRoleDetail"
					:parentId="modelId"
					/>
			</template>
			<template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentRoleDetailPage"
				:total-rows="totalRoleDetailRow"
				:per-page="roleDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template>
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template>
<style scoped>

::v-deep .center-text {
	padding: 5px !important;
	text-align: center !important;
	vertical-align: middle !important;
}

</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Role from '@/models/Role/Role';
import RoleList from '@/models/Role/RoleList';
import RoleFilter from '@/filters/Role/RoleFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import RoleDetail from '@/models/Role/RoleDetail';
import RoleDetailFilter from '@/filters/Role/RoleDetailFilter';
import FunctionInfo from '@/models/FunctionInfo/FunctionInfo';
import FunctionInfoFilter from '@/filters/FunctionInfo/FunctionInfoFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import RoleDetailInput from '@/views/Role/RoleDetailInput';
import RoleDetailUpload from '@/views/Role/RoleDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCheckbox,
		RoleDetailInput,RoleDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsRoleDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"functionInfo": { "class" : "th-function-info first-child", "label" : "Function", key: 'functionInfo', sortable: false}}, 
				{"allowCreate": { "class" : "th-number center-text", "label" : "Create", key: 'allowCreate', sortable: false}}, 
				{"allowRead": { "class" : "th-number center-text last-child", "label" : "Read", key: 'allowRead', sortable: false}}, 
				{"allowUpdate": { "class" : "th-number center-text d-stack-none", "label" : "Update", key: 'allowUpdate', sortable: false}}, 
				{"allowDelete": { "class" : "th-number center-text d-stack-none", "label" : "Delete", key: 'allowDelete', sortable: false}}, 
				{"showInMenu": { "class" : "th-number center-text d-stack-none", "label" : "Show In Menu", key: 'showInMenu', sortable: false}}, 
				{"allowDownload": { "class" : "th-number center-text d-stack-none", "label" : "Download", key: 'allowDownload', sortable: false}}, 
				{"allowPrint": { "class" : "th-number center-text d-stack-none", "label" : "Print", key: 'allowPrint', sortable: false}}, 
				{"allowUpload": { "class" : "th-number center-text d-stack-none", "label" : "Upload", key: 'allowUpload', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelRoleDetail : {},
			isShowPopupRoleDetail : false,
			isShowPopupUploadRoleDetail : false,
			filterRole : null,
			currentRolePage : 1,
			rolePageSize: 10,
			sortByRole: '',
			sortDescRole: '',
			filterRoleDetail : null,
			currentRoleDetailPage : 1,
			roleDetailPageSize: 10,
			sortByRoleDetail: '',
			sortDescRoleDetail: '',
			sortingByRoleDetail: [],
			roleDetails : [],
			roleDetailId : '',
			totalRoleDetailRow : 0,
			isShowRoleDetailFilter: false,
			isDownloadRoleDetail: false,
			functionInfos: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isRoleComboLoading: false,
			isFunctionInfoComboLoading: false,
		}
	},
	methods : {
		getRole : async function(id) {
			this.isBusy = true;
			Role.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadRole = true;
			this.filterRole.id = this.modelId;
			Role.downloadDataDetail(this, this.filterRole).then(result => {
				this.isDownloadRole = false;
			}).catch(error => { this.isDownloadRole = false; })
		},
		getRoleDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterRoleDetail);
			if (this.modelId == null) return;
			filter.roleId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByRoleDetail != null) {
				this.sortingByRoleDetail[this.sortByRoleDetail] = this.sortDescRoleDetail;
			}
			let currentPage = (this.currentRoleDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalRoleDetailRow + 1;
				let page = Math.ceil(totalData/this.roleDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			//currentPage = null;
			//this.roleDetailPageSize = 0;
			// disable paging end
			RoleDetail.getList(this, filter, this.sortingByRoleDetail, currentPage , this.roleDetailPageSize).then(result => {
				this.currentRoleDetailPage = currentPage + 1;
				this.roleDetails = result.data;
				this.totalRoleDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getRoles : async function(input) {
			let filter = new RoleFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isRoleComboLoading = true;
			Role.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.roles = result.data
				}
				this.isRoleComboLoading = false;
			})
			.catch(error => {});
		},
		getRoles : async function(input) {
			let filter = new RoleFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isRoleComboLoading = true;
			Role.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.roles = result.data
				}
				this.isRoleComboLoading = false;
			})
			.catch(error => {});
		},
		getFunctionInfos : async function(input) {
			let filter = new FunctionInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isFunctionInfoComboLoading = true;
			FunctionInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.functionInfos = result.data
				}
				this.isFunctionInfoComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.roleInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					Role.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'roleindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					Role.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'roleindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Role.updateData(this, model, id)
					.catch((error) => {
						this.getRole(id);
					});
				}
			});
		},
		onHidden() {
			this.getRoles();
		},
		addRowDataRoleDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.roleId =  this.modelId;
					RoleDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getRoleDetails(true);
						this.isShowPopupRoleDetail = false;
					})
				} else {
					model.roleId =  this.modelId;
					RoleDetail.createDataDetail(this, model)
					.then(result => {
						this.getRoleDetails(true);
						this.isShowPopupRoleDetail = false;
					})
				}
			}
		},
		async editRowDataRoleDetail(id) {
			this.roleDetailId = id;
			this.isShowPopupRoleDetail = true; 
		},
		async deleteRowDataRoleDetail(id) {
			RoleDetail.deleteData(this, id).then(result => { this.getRoleDetails(); });
		},
		async resetDataRoleDetail() {
			this.roleDetailId = "";
			this.isShowPopupRoleDetail = true;
		},
		async addDataRoleDetail() {
			RoleDetail.createData(this, { roleId: this.modelId })
			.then(result => {
				this.getRoleDetails(true);
			})
		},
		async addFromClipboardRoleDetail() {
			let functionInfos = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					functionInfos.push({ functionInfo: item, roleId: this.modelId });
				});
				RoleDetail.addFromClipboard(this, functionInfos).then(result => { this.getRoleDetails() });
			});
		},
		async replaceFromClipboardRoleDetail() {
			let functionInfos = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					functionInfos.push({ functionInfo: item, roleId: this.modelId });
				});
				RoleDetail.replaceFromClipboard(this, functionInfos).then(result => { this.getRoleDetails() });
			});   
		},
		showPopupUploadRoleDetail() {
			if(this.roleDetails != null && this.roleDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap RoleDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadRoleDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadRoleDetail = true;
			}
		},
		uploadDataRoleDetail(modalEvent, newDatas) {
			this.isShowPopupUploadRoleDetail = false; 
		},
		downloadRoleDetail(modalEvent) {
			this.isDownloadRoleDetail = true;
			this.filterRoleDetail.roleId = this.modelId;
			RoleDetail.downloadDataDetail(this, this.filterRoleDetail).then(result => {
				this.isDownloadRoleDetail = false;
			}).catch(error => { this.isDownloadRoleDetail = false; })
		},
		saveInputRoleDetail(item) {
			if (this.roles != null && this.roles != undefined  && this.roles.length > 0) {
				item.role = this.roles.find(q => q.id == item.roleId);
			}
			if (this.functionInfos != null && this.functionInfos != undefined  && this.functionInfos.length > 0) {
				item.functionInfo = this.functionInfos.find(q => q.id == item.functionInfoId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					RoleDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadRoleDetail = false; 
			this.isShowPopupRoleDetail = false; 
			if (modalType == 'RoleDetail') {
				this.getRoleDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowRoleDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterRole = new RoleFilter();
		this.filterRoleDetail = new RoleDetailFilter();
		//this.getRoles();
		//this.getFunctionInfos();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getRole(id);
			} else {
				this.modelId = id;
				this.getRole(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByRoleDetail : {
			handler: function() {
				this.getRoleDetails();
			}
		},
		sortDescRoleDetail: {
			handler: function() {
				this.getRoleDetails();
			}
		},
		currentRoleDetailPage: {
			handler: function() {
				this.getRoleDetails();
			}
		},
		roleDetailPageSize : {
			handler: function() {
				this.getRoleDetails();
			}
		},
		filterRoleDetail: {
			handler: function() {
				this.getRoleDetails();
			},
			deep: true,
		},
	},
}
</script>
